import React from "react";
import LoggedOutContainer from "../containers/logged-out-container";

const LoggedOutPage = () => (
  <main className="logged-out-page">
    <LoggedOutContainer />
  </main>
);

export default LoggedOutPage;
